const shipping_calculator = {
    zip: localStorage.getItem('zip'),
    checked_products: {},
    shipping_rates: [],
    now: new Date(),
    enabled: false,
    valid: false,
    monthNames: ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ],
    warehouses: {
        5850366007: { "index": 0, "id": 5850366007, "zip": "98006", "name": "4473 163RD PL SE" },
        70960414975: { "index": 1, "id": 70960414975, "zip": "75007", "name": "Dallas, TX Warehouse" },
        70971687167: { "index": 2, "id": 70971687167, "zip": "17001", "name": "Harrisburg, PA Warehouse" },
        61350445224: { "index": 1, "id": 61350445224, "zip": null, "name": "Flowspace" },
        61448519848: { "index": 2, "id": 61448519848, "zip": "19007", "name": "Flowspace - Bristol, PA - LZ Inventory" },
        61448487080: { "index": 3, "id": 61448487080, "zip": "19007", "name": "Flowspace - Bristol, PA - USA Inventory" },
        61448192168: { "index": 4, "id": 61448192168, "zip": "91748", "name": "Flowspace - Los Angeles (City of Industry) - LZ Inventory" },
        61311320232: { "index": 5, "id": 61311320232, "zip": "91748", "name": "Flowspace - Los Angeles (City of Industry) - USA Inventory" },
        63623102632: { "index": 6, "id": 63623102632, "zip": "35601", "name": "Decatur, AL Warehouse" }
    },
    init() {
        this.zip = localStorage.getItem('zip');
        this.checked_products = {};
        this.shipping_rates = [];
        
        if (this.zip != null) {
            this.getShippingRatesFromApp();
            document.querySelectorAll('.delivery-information').forEach(delivery_info_container => {
                delivery_info_container.classList.add('loading');
                delivery_info_container.classList.add('shimmer');
                const variant_id = delivery_info_container.dataset.variant;
                shipping_calculator.checkInventory(variant_id);
            });
        }

        this.enabled = true;
    },
    checkInventory(product_ids) {
        const $this = this;
        if (typeof $this.checked_products[product_ids] == 'undefined') {
            fetch('https://titancasket.mizu.a2hosted.com/index.php?id=' + product_ids)
                .then(res => res.text())
                .then(data => {
                    if (data.length > 0) {
                        $this.checked_products[product_ids] = {};
                        
                        try {
                            // available product
                            data = JSON.parse(data);
                            $this.checked_products[product_ids].available = data.inventory_levels;
                            $this.waitForShippingRates({ available: data.inventory_levels, variant: product_ids });

                        } catch (error) {
                            // not available
                            $this.checked_products[product_ids].available = false;
                        }
                    } else {
                        // not available or run again
                    }
                });
        }
    },
    waitForShippingRates(product) {
        const $this = this;
        if ($this.shipping_rates.length > 0) {
            $this.calculateDate(product);
        } else {
            setTimeout(() => { $this.waitForShippingRates(product); }, 150);
        }
    },
    getShippingRatesFromApp() {
        const $this = this;
        $.ajax({
            url: "/apps/postcode-shipping/quote",
            dataType: 'json',
            type: 'GET',
            data: {
                postal_code: $this.zip,
                country: 'US',
                province: $this.getState()
            },
            success: function (data) {
                if (data["rates"]) {
                    $this.valid = true;
                    $this.shipping_rates = data["rates"];
                } else {
                    // no rates available
                }
            }
        });
    },
    getState() {
        const zipString = this.zip;
        /* Ensure param is a string to prevent unpredictable parsing results */
        if (typeof zipString !== 'string') {
            console.log('Must pass the zipcode as a string.');
            return;
        }

        /* Ensure we have exactly 5 characters to parse */
        if (zipString.length !== 5) {
            console.log('Must pass a 5-digit zipcode.');
            return;
        }

        /* Ensure we don't parse strings starting with 0 as octal values */
        const zipcode = parseInt(zipString, 10);

        let st;
        let state;

        /* Code cases alphabetized by state */
        if (zipcode >= 35000 && zipcode <= 36999) {
            st = 'AL';
            state = 'Alabama';
        } else if (zipcode >= 99500 && zipcode <= 99999) {
            st = 'AK';
            state = 'Alaska';
        } else if (zipcode >= 85000 && zipcode <= 86999) {
            st = 'AZ';
            state = 'Arizona';
        } else if (zipcode >= 71600 && zipcode <= 72999) {
            st = 'AR';
            state = 'Arkansas';
        } else if (zipcode >= 90000 && zipcode <= 96699) {
            st = 'CA';
            state = 'California';
        } else if (zipcode >= 80000 && zipcode <= 81999) {
            st = 'CO';
            state = 'Colorado';
        } else if ((zipcode >= 6000 && zipcode <= 6389) || (zipcode >= 6391 && zipcode <= 6999)) {
            st = 'CT';
            state = 'Connecticut';
        } else if (zipcode >= 19700 && zipcode <= 19999) {
            st = 'DE';
            state = 'Delaware';
        } else if (zipcode >= 32000 && zipcode <= 34999) {
            st = 'FL';
            state = 'Florida';
        } else if ((zipcode >= 30000 && zipcode <= 31999) || (zipcode >= 39800 && zipcode <= 39999)) {
            st = 'GA';
            state = 'Georgia';
        } else if (zipcode >= 96700 && zipcode <= 96999) {
            st = 'HI';
            state = 'Hawaii';
        } else if (zipcode >= 83200 && zipcode <= 83999) {
            st = 'ID';
            state = 'Idaho';
        } else if (zipcode >= 60000 && zipcode <= 62999) {
            st = 'IL';
            state = 'Illinois';
        } else if (zipcode >= 46000 && zipcode <= 47999) {
            st = 'IN';
            state = 'Indiana';
        } else if (zipcode >= 50000 && zipcode <= 52999) {
            st = 'IA';
            state = 'Iowa';
        } else if (zipcode >= 66000 && zipcode <= 67999) {
            st = 'KS';
            state = 'Kansas';
        } else if (zipcode >= 40000 && zipcode <= 42999) {
            st = 'KY';
            state = 'Kentucky';
        } else if (zipcode >= 70000 && zipcode <= 71599) {
            st = 'LA';
            state = 'Louisiana';
        } else if (zipcode >= 3900 && zipcode <= 4999) {
            st = 'ME';
            state = 'Maine';
        } else if (zipcode >= 20600 && zipcode <= 21999) {
            st = 'MD';
            state = 'Maryland';
        } else if ((zipcode >= 1000 && zipcode <= 2799) || (zipcode == 5501) || (zipcode == 5544)) {
            st = 'MA';
            state = 'Massachusetts';
        } else if (zipcode >= 48000 && zipcode <= 49999) {
            st = 'MI';
            state = 'Michigan';
        } else if (zipcode >= 55000 && zipcode <= 56899) {
            st = 'MN';
            state = 'Minnesota';
        } else if (zipcode >= 38600 && zipcode <= 39999) {
            st = 'MS';
            state = 'Mississippi';
        } else if (zipcode >= 63000 && zipcode <= 65999) {
            st = 'MO';
            state = 'Missouri';
        } else if (zipcode >= 59000 && zipcode <= 59999) {
            st = 'MT';
            state = 'Montana';
        } else if (zipcode >= 27000 && zipcode <= 28999) {
            st = 'NC';
            state = 'North Carolina';
        } else if (zipcode >= 58000 && zipcode <= 58999) {
            st = 'ND';
            state = 'North Dakota';
        } else if (zipcode >= 68000 && zipcode <= 69999) {
            st = 'NE';
            state = 'Nebraska';
        } else if (zipcode >= 88900 && zipcode <= 89999) {
            st = 'NV';
            state = 'Nevada';
        } else if (zipcode >= 3000 && zipcode <= 3899) {
            st = 'NH';
            state = 'New Hampshire';
        } else if (zipcode >= 7000 && zipcode <= 8999) {
            st = 'NJ';
            state = 'New Jersey';
        } else if (zipcode >= 87000 && zipcode <= 88499) {
            st = 'NM';
            state = 'New Mexico';
        } else if ((zipcode >= 10000 && zipcode <= 14999) || (zipcode == 6390) || (zipcode == 501) || (zipcode == 544)) {
            st = 'NY';
            state = 'New York';
        } else if (zipcode >= 43000 && zipcode <= 45999) {
            st = 'OH';
            state = 'Ohio';
        } else if ((zipcode >= 73000 && zipcode <= 73199) || (zipcode >= 73400 && zipcode <= 74999)) {
            st = 'OK';
            state = 'Oklahoma';
        } else if (zipcode >= 97000 && zipcode <= 97999) {
            st = 'OR';
            state = 'Oregon';
        } else if (zipcode >= 15000 && zipcode <= 19699) {
            st = 'PA';
            state = 'Pennsylvania';
        } else if (zipcode >= 300 && zipcode <= 999) {
            st = 'PR';
            state = 'Puerto Rico';
        } else if (zipcode >= 2800 && zipcode <= 2999) {
            st = 'RI';
            state = 'Rhode Island';
        } else if (zipcode >= 29000 && zipcode <= 29999) {
            st = 'SC';
            state = 'South Carolina';
        } else if (zipcode >= 57000 && zipcode <= 57999) {
            st = 'SD';
            state = 'South Dakota';
        } else if (zipcode >= 37000 && zipcode <= 38599) {
            st = 'TN';
            state = 'Tennessee';
        } else if ((zipcode >= 75000 && zipcode <= 79999) || (zipcode >= 73301 && zipcode <= 73399) || (zipcode >= 88500 && zipcode <= 88599)) {
            st = 'TX';
            state = 'Texas';
        } else if (zipcode >= 84000 && zipcode <= 84999) {
            st = 'UT';
            state = 'Utah';
        } else if (zipcode >= 5000 && zipcode <= 5999) {
            st = 'VT';
            state = 'Vermont';
        } else if ((zipcode >= 20100 && zipcode <= 20199) || (zipcode >= 22000 && zipcode <= 24699) || (zipcode == 20598)) {
            st = 'VA';
            state = 'Virgina';
        } else if ((zipcode >= 20000 && zipcode <= 20099) || (zipcode >= 20200 && zipcode <= 20599) || (zipcode >= 56900 && zipcode <= 56999)) {
            st = 'DC';
            state = 'Washington DC';
        } else if (zipcode >= 98000 && zipcode <= 99499) {
            st = 'WA';
            state = 'Washington';
        } else if (zipcode >= 24700 && zipcode <= 26999) {
            st = 'WV';
            state = 'West Virginia';
        } else if (zipcode >= 53000 && zipcode <= 54999) {
            st = 'WI';
            state = 'Wisconsin';
        } else if (zipcode >= 82000 && zipcode <= 83199) {
            st = 'WY';
            state = 'Wyoming';
        } else {
            st = 'none';
            state = 'none';
            console.log('No state found matching', zipcode);
        }
        return state;
    },
    calculateDate(product) {
        let rate = this.shipping_rates[0], days, warehouse = false, available_warehouses = [];
        if (product.available) {
            product.available.forEach(function (location, index) {
                if (location.available > 0) {
                    available_warehouses[available_warehouses.length] = location.location_id;
                }
            });
            available_warehouses.forEach(function (id, index) {
                if (shipping_calculator.warehouses[id] != null) {
                    available_warehouses[index] = shipping_calculator.warehouses[id].index;
                }
            });
            if (available_warehouses.length == 1) {
                warehouse = available_warehouses[0];
            }
        }
        let count_days = 100;
        this.shipping_rates.forEach(el => {
            let reg = parseInt(el.description.match(/\d+/)),
                temp_warehouse = parseInt(el.service_code.match(/\d+/)) - 1;
            reg += processing_times[temp_warehouse];
            if (reg < count_days &&
                (available_warehouses.length > 0 && available_warehouses.includes(temp_warehouse))) {
                rate = el;
                count_days = reg;
                if (available_warehouses.length != 1) {
                    warehouse = temp_warehouse;
                }
            }
        });
        days = rate.description.match(/\d+/);
        days = (days != null) ? parseInt(days[0]) : shipping_time.max;

        if (warehouse === false) {
            warehouse = this.chooseWarehouse();
        }
        let date = this.defineDate(days, warehouse);
        // build date
        if (document.querySelector(`#delivery_${product.variant}:not([data-out-of-stock="true"])`)) {
            this.renderDate(document.querySelector(`#delivery_${product.variant}:not([data-out-of-stock="true"])`) ,date);
        } else {
            document.querySelector(`#delivery_${product.variant}[data-out-of-stock="true"]`).classList.remove('loading');
            document.querySelector(`#delivery_${product.variant}[data-out-of-stock="true"]`).classList.remove('shimmer');
        }

    },
    chooseWarehouse() {
        let days = 100, warehouse = 0;
        processing_times.forEach(function (item, index) {
            if (days > item) {
                days = item;
                warehouse = index;
            }
        });
        return warehouse;
    },
    addDays: function (theDate, days) {
        return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
    },
    getWeekDay: function (day) {
        let weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return weekday[day];
    },
    getMonth: function (month) {
        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        return months[month];
    },
    defineDate: function (days, warehouse = 0) {
        let date = this.checkOff(this.now, days + parseInt(processing_times[warehouse]));
        return date;
    },
    checkOff: function (dispatch, days) {
        let off = 0, newDate, date_str, new_dispatch = new Date(dispatch);
        while (off < days) {
            newDate = new Date(new_dispatch.setDate(new_dispatch.getDate() + 1));
            date_str = (newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate()) +
                '/' + ((newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1));
            if (newDate.getDay() != 0 && newDate.getDay() != 6 && !shipping_days_off.includes(date_str)) {
                //Date.getDay() gives weekday starting from 0(Sunday) to 6(Saturday)
                off++;
            }
        }
        return newDate;
    },
    renderDate(container, date) {
        container.innerHTML = `Delivery by ${this.monthNames[date.getMonth()]} ${date.getDate()}`;
        container.setAttribute('data-mobile-date', `Delivery by ${this.monthNames[date.getMonth()].slice(0,3)} ${date.getDate()}`)
        container.classList.remove('loading');
        container.classList.remove('shimmer');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    shipping_calculator.init();

    let shippingEstimatorSubmitBtns = document.querySelectorAll('.estimated-delivery-date .field__button');
    
    if (shippingEstimatorSubmitBtns) {
        for (const shippingEstimatorSubmitBtn of shippingEstimatorSubmitBtns) {
            if (localStorage.getItem('zip')) {
                let input = shippingEstimatorSubmitBtn.closest('.estimated-delivery-date').querySelector('.field__input');

                input.value = localStorage.getItem('zip');
            }

            shippingEstimatorSubmitBtn.addEventListener('click', e => {
                let shippingEstimatorEnteredZip = e.target.closest('.estimated-delivery-date').querySelector('.field__input');
    
                if (shippingEstimatorEnteredZip) {
                    localStorage.setItem('zip', shippingEstimatorEnteredZip.value);
                    shipping_calculator.init();
                }
            });
        }
    }
});